export default params => (
  params.ticketId !== 'select' &&
  params.ticketId !== 'message' &&
  params.ticketId !== 'confirm' &&
  !!params.ticketId
);
